import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#F24142") => (
    <>
        <path
            d="M15.2067 3.80127C15.5909 3.41735 16.2186 3.4228 16.609 3.81299C16.9996 4.20351 17.005 4.83206 16.6208 5.21631L15.068 6.76807C15.22 7.28602 15.3004 7.82655 15.3004 8.37549C15.3004 12.4186 11.7635 15.7615 10.1979 17.0435C9.97308 17.2275 9.86043 17.3195 9.69303 17.3667C9.5629 17.4033 9.37099 17.4033 9.24088 17.3667C9.07403 17.3196 8.96073 17.2267 8.73697 17.0435C8.21434 16.6155 7.47356 15.9564 6.71646 15.1196L4.79361 17.0435C4.40937 17.4277 3.78082 17.4223 3.39029 17.0317C3.00003 16.6412 2.99539 16.0136 3.37955 15.6294L15.2067 3.80127Z"
            fill={color}/>
        <path
            d="M9.46744 2.60596C10.8078 2.60598 12.1004 3.06267 13.1335 3.88818L10.3463 6.67529C10.0768 6.55908 9.77956 6.49465 9.46744 6.49463C8.24014 6.49463 7.24478 7.48999 7.24478 8.71729C7.24481 9.02962 7.31005 9.32656 7.42642 9.59619L4.70572 12.3169C4.07178 11.1286 3.63453 9.79544 3.63443 8.37549C3.63443 6.84539 4.24848 5.37735 5.34244 4.29541C6.43637 3.21358 7.92044 2.60597 9.46744 2.60596Z"
            fill={color}/>
    </>
)

export const MapPinOff: React.FC<IconProps> = ({color, className, size = 20}) => (
    <IconWrapper {...{size, color, renderIcon, className}} viewBox={'0 0 20 20'}/>
)
